import React from 'react';
import { connect } from 'react-redux';
import './paginationStyle.less';

const Pagination = (props) => {
  const { images } = props;
  const { activeImage } = props;
  return images.gallery.length > 1
  ? (
      <div className="pagination">
        {images.gallery.map((point, i) => {
          let pointerClassName = 'point';
          if (activeImage === i) {
            pointerClassName = 'point activePoint';
          } else if (activeImage === (i + 1) || activeImage === (i - 1)) {
            pointerClassName = 'point midSizePoint';
          } else if (activeImage === (i + 2) || activeImage === (i - 2)) {
            pointerClassName = 'point smallSizePoint';
          } else if (activeImage > (i + 3) || activeImage < (i - 3)) {
            pointerClassName = 'point hideItQuick';
          }

          return (
            <div className={pointerClassName} key={point.thumb} />
          );
        })}
      </div>
  )
  : null;
};

const mapStateToProps = ({ app, gallery }) => {
  return {
    activeImage: gallery.activeImage,
    images: app.data.images,
  };
};

export default connect(mapStateToProps)(Pagination);
